<style>
@import '../../../custom/css/lista-dicas.css';
</style>

<template>
  <div id="representantes">
    <h1 class="title text-uppercase font-weight-bold">
      Afiliados não avaliados
    </h1>
    <hr class="linha-amarela" />
    <table class="table" v-if="getUnvaluedAffiliates.length !== 0">
      <thead class="letter-orange">
        <tr>
          <th></th>
          <th>Nome</th>
          <th>E-mail</th>
          <th v-if="hasWritePermission()">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(affiliate, index) in getUnvaluedAffiliates" :key="index">
          <td class="font-weight-bold fs-20">
            {{ index + 1 }}
          </td>
          <td>
            {{ affiliate.nome || 'Sem nome' }}
          </td>
          <td>
            {{ affiliate.email || 'Sem e-mail' }}
          </td>
          <td v-if="hasWritePermission()">
            <b-btn
              class="btn-success mr-1"
              @click="seeAffiliate(affiliate.id)"
              title="Avaliar"
            >
              <i class="fas fa-tasks"></i>
            </b-btn>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else>
      <p>Sem afiliados a serem avaliados</p>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import makeToast from '../../../mixins/makeToast';

export default {
  name: 'UnvaluedAffiliates',
  mixins: [makeToast],
  computed: {
    ...mapGetters('affiliate', ['getUnvaluedAffiliates']),
    ...mapState(['token', 'dadosUsuario']),
  },
  created() {
    this.getUnvalued();
  },
  methods: {
    ...mapActions('affiliate', ['getUnvalued']),
    editAffiliate(id) {
      this.$router.push({
        name: 'administrador-editar-afiliado',
        params: { id },
      });
    },
    seeAffiliate(id) {
      this.$router.push({
        name: 'administrador-ver-afiliado',
        params: { id },
      });
    },
    hasWritePermission() {
      return this.dadosUsuario.permitido_escrita == 1;
    },
  },
};
</script>
